import React from 'react';
import moment from 'moment-timezone';
import Descriptions from 'antd/lib/descriptions';

// import AntdTable from 'antd/lib/table';
import isArray from 'lodash/isArray';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';
import Types from '../../modules/types';
// import { getServerHost } from '../../helpers/copyToClipboard';
// import getRoleBasedPath from '../../helpers/getRoleBasedPath';

// import { IssuesPopover } from '../orders/columns';

import { renderCurrency } from '../../components/SystemCountry';

import {
  OrderDescription,
  OrderDescriptionSectionSeparator,
  DescriptionLabel,
  DescriptionValue,
} from '../orders/fields/edit';

export const CREATE = [];

export const EDIT = [
  ['FieldReact', {
    name: 'customer',
    renderContent: (props) => {
      // eslint-disable-next-line no-unused-vars
      const { data, viewer } = props;
      // const systemCountry = Types.getSystemCountry(data.systemCountry);
      // const isAdmin = viewer && viewer.role === 'ADMIN';
      return [
        ['Details', [
          ['Name', data.customerDetails.name],
          ['Email', data.customerDetails.email],
          ['Phone', data.customerDetails.phoneNumberString],
          (
            viewer?.role === 'ADMIN' && data.store
            ? ['Store', (
                <Link key="store" to={`/stores/${data.store._id}`}>
                  {data.store.name}
                </Link>
              )]
            : null
          ),
        ]],
        ['Stats', [
          ['Delivered Orders', data.stats.orderCountDelivered || 0],
          [
            'Total Spent',
            renderCurrency({
              prefix: `${Types.decimalize(data.stats.orderCostTotal)} `,
            }),
          ],
          [
            'Average Spent Per Order',
            renderCurrency({
              prefix: `${Types.decimalize(data.stats.orderCostAvg)} `,
            }),
          ],
          [
            'Highest Spent Per Order',
            renderCurrency({
              prefix: `${Types.decimalize(data.stats.orderCostMax)} `,
            }),
          ],
          [
            'Lowest Spent Per Order',
            renderCurrency({
              prefix: `${Types.decimalize(data.stats.orderCostMin)} `,
            }),
          ],
          [
            'First Order',
            moment(data.stats.firstOrderDate).format('DD.MM.YYYY. HH:mm'),
          ],
          [
            'Last Order',
            moment(data.stats.lastOrderDate).format('DD.MM.YYYY. HH:mm'),
          ],
        ]],
        // (
        //   isAdmin
        //   ? ([
        //     'Stores', [
        //       ...data.stores.map(store => ([
        //         store.storeId,
        //         <Link
        //           key={store._id}
        //           to={getRoleBasedPath(
        //             props,
        //             `/stores/${store._id}`,
        //           )}
        //         >
        //           {store.name}
        //         </Link>,
        //       ])),
        //     ],
        //   ])
        //   : null
        // ),
      ].reduce(
        // eslint-disable-next-line no-unused-vars
        (sections, section, index, initialSectionsArray) => {
          if (section) {
            if (section[2]) {
              sections.push(section);
            } else {
              const { key = section[0] } = section[3] || { key: section[0] };
              sections.push(
                <OrderDescriptionSectionSeparator
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${key}-${index}-separator`}
                />
              );
              const {
                valueProps = {},
                ...descriptionProps
              } = section[3] || {};
              sections.push(
                <OrderDescription
                  key={key}
                  title={section[0]}
                  column={1}
                  size="small"
                  // colon={false}
                  bordered={isArray(section[1])}
                  {...descriptionProps}
                >
                  {
                    isArray(section[1])
                      ? section[1].reduce(
                        (list, item) => {
                          if (item) {
                            list.push(
                              <Descriptions.Item
                                key={item[0]}
                                label={(
                                  <DescriptionLabel>
                                    {item[0]}
                                  </DescriptionLabel>
                                )}
                              >
                                <DescriptionValue {...valueProps}>
                                  {item[1]}
                                </DescriptionValue>
                              </Descriptions.Item>
                            );
                          }
                          return list;
                        },
                        [],
                      )
                      : section[1]
                  }
                </OrderDescription>
              );
            }
          }
          return sections;
        },
        [],
      );
    },
  }],
  // ['FieldTable', {
  //   name: 'details',
  //   label: 'Addresses',
  //   table: {
  //     showHeader: true,
  //   },
  //   columns: [
  //     ['streetName', 'Street Name'],
  //     ['streetNumber', 'Street Number'],
  //     ['postalCode', 'Postal Code'],
  //     ['city', 'City'],
  //     // eslint-disable-next-line max-len
  //     ['country', 'Country', (record) => Types.COUNTRIES_MAP[record.country].name],
  //   ].map(([key, label, get]) => ({
  //     key,
  //     title: label,
  //     getLabel: get || (({ [key]: value }) => value),
  //   })),
  // }],
  ['FieldTable', {
    name: 'orders',
    label: 'Orders',
    table: {
      showHeader: true,
    },
    // disabled: true,
    getColumns: (props) => (
      [
        // eslint-disable-next-line max-len
        ['_id', 'ID', (record) => (
          <Link
            to={
                props?.viewer?.role === 'ADMIN'
              ? `/orders/${record._id}`
              : `/store/orders/${record._id}`
            }
          >
            {record._id}
          </Link>
        )],
        // eslint-disable-next-line max-len
        ['status', 'Status', (record) => Types.ORDER_STATUS_LABELS_MAP[record.status]],
        // eslint-disable-next-line max-len
        ['createdAt', 'Created At', (record) => moment(record.createdAt).format('DD.MM.YYYY. HH:mm')],
        // eslint-disable-next-line max-len
        ['cost.charged', 'Amount', (record) => `${Types.decimalize(record.cost.charged)} ${Types.getSystemCountry(record.systemCountry).currency}`],
        (
          props.viewer && props.viewer.role === 'ADMIN'
          ? [
            'store.name',
            'Store',
            record => (
              <Link
                to={`/stores/${record.store._id}`}
              >
                {record.store.name}
              </Link>
            ),
          ]
          : null
        ),
      ]
      .filter(item => item !== null)
      .map(([key, label, get]) => ({
        key,
        title: label,
        getLabel: get || (({ [key]: value }) => value),
      }))
    ),
  }],
];
